export const blockIconsCommonactionsTouchAppNew = (
	<span className='material-symbols-outlined'>touch_app</span>
);
